import { useState } from 'react';
import { dashboardApi } from '@/services/dashboardApi';
import { useLoad, Loading, eur, num, pct, MONTHS, inputCls, yearOptions } from './ui';

// Cuadros mensuales (antes CM_FINANZAS y CM_VENTAS)
const VIEWS = {
  Finanzas: [
    ['income', 'Ingresos cobrados', eur, 'sum'], ['expenses', 'Gastos totales', eur, 'sum'],
    ['exp_publicidad', '· publicidad', eur, 'sum'], ['exp_comisiones', '· comisiones', eur, 'sum'],
    ['exp_nominas', '· nóminas', eur, 'sum'], ['exp_amaroo', '· alquiler Amaroo a CBC', eur, 'sum'],
    ['result', 'Resultado del mes', eur, 'sum'], ['margin', 'Margen neto', pct, null],
    ['result_cum', 'Resultado acumulado', eur, 'last'], ['cash', 'Caja a cierre', eur, 'last'],
    ['runway', 'Autonomía de caja (meses)', (v) => num(v, 1), 'last'], ['pending_collection', 'Pendiente de cobro', eur, 'last'],
    ['capital_fhct_active', 'Capital en FHCT vigente', eur, 'last'], ['fhct_commissions', 'Comisiones FHCT', eur, 'sum'],
    ['intercompany_for_fhc', 'Deuda intercompañía a favor de FHC', eur, 'last'], ['cfo_trigger', 'Disparador CFO', (v) => (v ? 'Sí' : '—'), null],
  ],
  Ventas: [
    ['altas', 'Altas de membresía', num, 'sum'], ['altas_access', '· Access', num, 'sum'], ['altas_pro', '· PRO', num, 'sum'],
    ['altas_premium', '· Premium', num, 'sum'], ['volume', 'Volumen de membresías', eur, 'sum'],
    ['collected', 'Cobrado en el mes', eur, 'sum'], ['collected_membership_cum', 'Cobrado en membresías (acumulado)', eur, 'last'],
    ['fhct_sold', 'FHCT vendidos', num, 'sum'], ['fhct_contribution', 'Aportación en FHCT (EUR)', eur, 'sum'],
    ['bricks_issued', 'Bricks emitidos', (v) => num(v, 1), 'sum'], ['fhct_purchases', 'Compras de FHCT', num, 'sum'],
    ['brokers_new', 'Brokers nuevos', num, 'sum'], ['brokers_selling', 'Brokers con venta', num, null],
    ['altas_bootcamp', 'Altas con bootcamp', num, 'sum'], ['altas_paid_ads', 'Altas por anuncio pagado', num, 'sum'],
    ['altas_organic', 'Altas orgánicas y por referido', num, 'sum'],
  ],
};

export default function CdmMensual({ cdm }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [view, setView] = useState('Finanzas');
  const { data, error } = useLoad(() => dashboardApi.cdmMonthly(year), [year]);
  return (
    <div className="space-y-4" data-testid="cdm-mensual">
      <div className="flex flex-wrap gap-3 items-center">
        <div className="flex gap-1 rounded-xl border border-white/[0.06] bg-white/[0.02] p-1">
          {Object.keys(VIEWS).map((v) => (
            <button key={v} onClick={() => setView(v)} className={`px-3 py-1.5 rounded-lg text-sm ${view === v ? 'bg-[#c9a84c]/15 text-[#c9a84c]' : 'text-gray-400'}`}>{v}</button>
          ))}
        </div>
        <select value={year} onChange={(e) => setYear(Number(e.target.value))} className={inputCls} aria-label="Año">
          {yearOptions(cdm).map((y) => <option key={y} value={y} className="bg-[#0d1829]">{y}</option>)}
        </select>
      </div>
      {!data ? <Loading error={error} /> : (
        <div className="overflow-x-auto rounded-xl border border-white/[0.06]">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-[11px] uppercase tracking-wider text-gray-400 border-b border-white/[0.06] bg-white/[0.015]">
                <th scope="col" className="px-3 py-2 text-left sticky left-0 bg-[#0b1426]">Concepto</th>
                {MONTHS.map((m) => <th key={m} scope="col" className="px-3 py-2 text-right">{m}</th>)}
                <th scope="col" className="px-3 py-2 text-right">Año</th>
              </tr>
            </thead>
            <tbody>
              {VIEWS[view].map(([key, label, f, agg]) => {
                const vals = data.rows.map((r) => r[key]);
                const total = agg === 'sum' ? vals.reduce((a, b) => a + (b || 0), 0) : agg === 'last' ? vals[vals.length - 1] : null;
                return (
                  <tr key={key} className="border-b border-white/[0.04]">
                    <th scope="row" className={`px-3 py-2 text-left font-normal sticky left-0 bg-[#0b1426] whitespace-nowrap ${label.startsWith('·') ? 'text-gray-400 pl-6' : 'text-white'}`}>{label}</th>
                    {vals.map((v, i) => <td key={i} className="px-3 py-2 text-right tabular-nums text-gray-300 whitespace-nowrap">{v ? f(v) : '—'}</td>)}
                    <td className="px-3 py-2 text-right tabular-nums text-white whitespace-nowrap">{total === null ? '—' : f(total)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
